import React from "react";

export function SvgPlus() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="none" viewBox="0 0 20 22">
			<path
				fill="#595959"
				stroke="#595959"
				strokeWidth="0.3"
				d="M10 2.128c-4.411 0-8 3.82-8 8.514 0 4.694 3.589 8.513 8 8.513 4.412 0 8-3.82 8-8.513 0-4.694-3.588-8.514-8-8.514zm0 15.709c-3.727 0-6.76-3.228-6.76-7.195S6.272 3.447 10 3.447s6.76 3.228 6.76 7.195-3.032 7.195-6.76 7.195z"
			></path>
			<path
				fill="#595959"
				stroke="#595959"
				strokeWidth="0.3"
				d="M13.098 9.923h-2.479V7.285c0-.364-.277-.66-.62-.66-.342 0-.62.296-.62.66v2.638H6.902c-.343 0-.62.296-.62.66 0 .364.277.659.62.659H9.38v2.638c0 .364.277.66.62.66.342 0 .619-.296.619-.66v-2.638h2.479c.342 0 .62-.295.62-.66 0-.364-.278-.659-.62-.659z"
			></path>
		</svg>
	);
}
